import Vue from 'vue';
import Vuex from 'vuex';
import { Notification } from '@swisscom/sdx';

import SubjectResponse from '../models/responses/SubjectResponse';
import UserResponse from '../models/responses/UserResponse';
import GradeResponse from '../models/responses/GradeResponse';
import SemesterResponse from '../models/responses/SemesterResponse';
import SubjectDetailResponse from '../models/responses/SubjectDetailResponse';
import BackNavigation from '../models/BackNavigation';
import Modal from '../models/Modal';
import { i18n } from '../main';

Vue.use(Vuex);

/**
 * the vuex store to store variables globally
 */
export default new Vuex.Store({
  state: {
    user: null as UserResponse | null,
    selectedSemester: null as SemesterResponse | null,
    selectedSubject: null as SubjectResponse | null,
    isSemesterSubjectFormOpen: false as boolean,
    isGradeFormOpen: false as boolean,
    isWishGradeFormOpen: false as boolean,
    isNotificationOpen: false as boolean,
    editSemester: null as SemesterResponse | null,
    editSubject: null as SubjectDetailResponse | null,
    editGrade: null as GradeResponse | null,
    notificationMessage: '' as string,
    backNavigation: null as BackNavigation | null,
    modal: {
      title: '',
      text: '',
      confirmationCallback: undefined,
    } as Modal,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setSelectedSemester(state, semester) {
      state.selectedSemester = semester;
    },
    setSelectedSubject(state, subject) {
      state.selectedSubject = subject;
      localStorage.setItem('subject', JSON.stringify(subject));
    },
    toggleGradeForm(state) {
      state.isGradeFormOpen = !state.isGradeFormOpen;
    },
    setEditGrade(state, grade) {
      state.editGrade = grade;
    },
    toggleSemesterSubjectForm(state) {
      state.isSemesterSubjectFormOpen = !state.isSemesterSubjectFormOpen;
    },
    toggleWishGradeForm(state) {
      state.isWishGradeFormOpen = !state.isWishGradeFormOpen;
    },
    setEditSemester(state, semesterName) {
      state.editSemester = semesterName;
    },
    setEditSubject(state, SubjectName) {
      state.editSubject = SubjectName;
    },
    resetEditForms(state) {
      state.editGrade = null;
      state.editSemester = null;
      state.editSubject = null;
    },
    setNotification(state, message) {
      state.notificationMessage = message;
    },
    setBackNavigation(state, navigation) {
      state.backNavigation = navigation;
    },
    openModal(state, modal) {
      state.modal = modal;
      (document.getElementById('modal') as HTMLSdxDialogElement).open();
    },
  },
  actions: {
    showNotification({ state, commit }, { type, key, text, message = '' }) {
      if (key && typeof key === 'string') message = i18n.t(key, [text]);
      commit('setNotification', message);
      const notification = Notification.showOnHeader(
        'header',
        state.notificationMessage,
        undefined,
        () => notification.close(),
        type ? `notification--${type}` : undefined,
      );
      setTimeout(() => {
        notification.close();
        commit('setNotification', '');
      }, 3000);
    },
  },
  getters: {
    isCoach(state): boolean {
      if (!state.user || !state.user.roles) return false;
      return state.user.roles.includes('ROLE_COACH');
    },
    isApprentice(state): boolean {
      if (!state.user || !state.user.roles) return false;
      return state.user.roles.includes('ROLE_APPRENTICE');
    },
  },
  modules: {},
});
